import React, { CSSProperties } from "react";
import { OutletPopularCategory } from "./OutletPopularCategory";
const imageStyle: CSSProperties = {
  mixBlendMode: "darken",
  alignSelf: "center"
};
const headerStyle: CSSProperties = {
  textShadow: "none"
};
interface Props {
  popularCategories: OutletPopularCategory[];
}
const OutletPopularCategoryCards = ({
  popularCategories
}: Props) => {
  return popularCategories?.length ? <div data-component="outlet-top-categories" className="flex flex-col md:flex-row -mx-3" data-sentry-component="OutletPopularCategoryCards" data-sentry-source-file="OutletPopularCategoryCards.tsx">
      {popularCategories.map((category: OutletPopularCategory, index: number) => <div className="flex flex-1 md:flex-col items-center md:justify-between bg-gray-50 border border-solid border-gray-200  mx-3 mb-3 px-3 pt-5 pb-6 sm:pb-5 rounded shadow-sm ">
            <img src={category.image.medium} alt="" style={imageStyle} className="max-w-xs w-3/12 md:w-5/12 mr-5 md:mr-0 self-center" />
            <div className="md:text-center w-11/12">
              <p className="text-xl text-red-600 font-semibold mb-0 leading-snug">
                {index === 0 && "Save Big on"}
                {index === 1 && "Limited Time Savings"}
                {index === 2 && "Great Deals on"}
              </p>
              <h2 className="text-xl md:text-2xl font-semibold leading-none mb-4" style={headerStyle}>
                {category.label}
              </h2>
              <a href={category.filterUrl} className="btn btn-info py-1 sm:py-2" aria-label={`Shop All ${category.label}`}>
                Shop All
              </a>
            </div>
          </div>)}
    </div> : null;
};
export default OutletPopularCategoryCards;